import { useMutation, useQuery } from 'react-query';
import { fetchTemplatesByConfig, getAllTemplateConfig } from 'src/apis/templateConfig';
import { AllTemplateConfigResponse, GetTemplatesByConfigPayload, GetTemplatesByConfigResponse } from 'types';

export const useGetAllTemplateConfig = () => {
	return useQuery({
		queryKey: ['getAllTemplateConfig'],
		queryFn: async () => (await getAllTemplateConfig()) as AllTemplateConfigResponse,
		staleTime: 0,
		enabled: true,
		refetchOnMount: true,
	});
};
export const useFetchTemplatesByConfig = ({
	experienceLevel,
	careerPath,
	developmentRole,
	techStack,
}: GetTemplatesByConfigPayload) => {
	return useQuery({
		queryKey: ['fetchTemplatesByConfig', experienceLevel, careerPath, developmentRole, techStack],
		queryFn: async () =>
			(await fetchTemplatesByConfig({
				experienceLevel,
				careerPath,
				developmentRole,
				techStack,
			})) as GetTemplatesByConfigResponse,
		staleTime: 0,
		enabled: true,
		refetchOnMount: true,
	});
};
